module.exports = __webpack_public_path__ + "static/media/ejection.80e275c4.JPEG";